import React, { useEffect, useState } from "react";
import VideoService from "../../services/KangarooServices/VideoService";
import {
  Button,
  Badge,
  Card,
  CardImg,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../Components/Common/DeleteModal";
import { imageBaseApi } from "../../utilis/imageHelper";
import toast from "react-hot-toast";

const Video = () => {
  const navigate = useNavigate();

  const [isSelectMode, setIsSelectMode] = useState(false);
  
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
    const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  
  const [selectedItems, setSelectedItems] = useState([]);
  const [data, setData] = useState([]);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);
const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };


  const handleDelete = async () => {
      if (selectedDeleteItem) {
        try {
          await VideoService.delete(selectedDeleteItem.id);
          fetchPage(currentPage, pageSize);
          toast.success("Page deleted successfully");
        } catch (error) {
          toast.error(error?.response?.data?.message || "Failed to delete page");
        } finally {
          toggleDelete();
          setSelectedDeleteItem(null);
        }
      }
    };
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const result = await VideoService.getdata();
      setData(result);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggleSelectItem = (item) => {
    if (selectedItems.some((i) => i.id === item.id)) {
      setSelectedItems(selectedItems.filter((i) => i.id !== item.id));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const clearSelection = () => setSelectedItems([]);

  const toggleDetailModal = (item) => {
    // Implement detail modal if needed
    console.log("Open detail modal for:", item);
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Media Gallery" pageTitle="Media" />

        {/* Header */}
        <Row className=" mb-4">
          <Col md={6} className="">
            {!isSelectMode && (
              <div className="d-inline-flex gap-2">
                {/* <Button
                  color="outline-primary"
                  onClick={() => setIsSelectMode(true)}
                >
                  <i className="bx bx-check-square me-1" />
                  Bulk
                </Button> */}
                <Button color="success" onClick={() => navigate("/video-form")}>
                  <i className="bx bx-plus me-1" />
                  Add Video
                </Button>
              </div>
            )}
          </Col>
        </Row>

        {/* Loading & Empty State */}
        {isLoading ? (
          <div className="text-center d-flex justify-content-center align-items-center py-5">
            <span>Loading...</span>
          </div>
        ) : data.length === 0 ? (
          <div className="text-center py-5">
            <i className="bx bx-image fs-1 text-muted d-block mb-3" />
            <h5>No media found</h5>
            <Button color="primary">Upload your first file</Button>
          </div>
        ) : (
          <>
            {/* Select all */}
            {isSelectMode && (
              <div className="mb-3 p-3 bg-white rounded d-flex align-items-center justify-content-between">
                <label className="d-flex align-items-center mb-0 cursor-pointer">
                  <Input
                    type="checkbox"
                    checked={
                      selectedItems.length === data.length && data.length > 0
                    }
                    onChange={() =>
                      selectedItems.length === data.length
                        ? setSelectedItems([])
                        : setSelectedItems([...data])
                    }
                    className="me-2"
                  />
                  <span>Select all {data.length} items</span>
                </label>

                <div className="d-inline-flex align-items-center gap-3">
                  <Badge color="primary" pill className="fs-14 px-3 py-2">
                    {selectedItems.length} selected
                  </Badge>
                  <Button
                    color="danger"
                    size="sm"
                    disabled={selectedItems.length === 0}
                  >
                    <i className="bx bx-trash " />
                  </Button>
                  <Button color="light" size="sm" onClick={clearSelection}>
                    <i className="bx bx-x"></i>
                  </Button>
                </div>
              </div>
            )}

            {/* Media Grid */}
            <Row className="g-3">
              {data.map((item) => {
                const media = item.thumbnailMedia;
                const isSelected = selectedItems.some((i) => i.id === item.id);
                const isImage = media?.fileName?.match(
                  /\.(jpg|jpeg|png|gif)$/i
                );

                return (
                 <Col key={item.id} lg={2} md={3} className="position-relative">
  <Card
    className={`h-100 border-0 rounded-3 overflow-hidden cursor-pointer shadow-sm ${
      isSelected ? "border-primary" : "border-transparent"
    }`}
    onClick={() => navigate(`details/${item.id}`)}
    style={{
      transition: "all 0.2s ease-in-out",
      transform: isSelected ? "scale(0.97)" : "scale(1)",
      border: isSelected ? "3px solid #556ee6" : "3px solid transparent",
      position: "relative", // important for absolute children
    }}
  >
    {isSelectMode && (
      <div className="position-absolute top-2 start-2 z-index-10">
        <Input
          type="checkbox"
          checked={isSelected}
          onChange={() => toggleSelectItem(item)}
          onClick={(e) => e.stopPropagation()}
          style={{
            width: "20px",
            height: "20px",
            accentColor: "#556ee6",
          }}
        />
      </div>
    )}

    {isImage ? (
      <CardImg
        top
        src={`${imageBaseApi}${media?.url}`}
        alt={media?.fileName}
        style={{
          objectFit: "contain",
          height: "220px",
          width: "100%",
        }}
        loading="lazy"
        className="transition-all"
      />
    ) : (
      <div
        className="d-flex align-items-center justify-content-center bg-light text-muted"
        style={{
          height: "220px",
          fontSize: "50px",
          transition: "all 0.2s",
        }}
      >
        <i className="bx bx-file-blank" />
      </div>
    )}

    {/* Overlay for title and buttons */}
    <div
      className="position-absolute bottom-0 start-0 end-0 p-2 d-flex flex-column justify-content-end"
      style={{
        background: "linear-gradient(180deg, transparent, rgba(0,0,0,0.7))",
        color: "#fff",
        gap: "4px",
      }}
    >
      <div>
        <div className="text-truncate fw-semibold">{item.title}</div>
        <small className="d-block">
          {item.relatedUniversityName ||
            item.relatedCountryName ||
            "Unknown"}
        </small>
      </div>

      {/* Edit & Delete icons */}
      <div className="d-flex gap-2">
        <Button
          color="light"
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/video-form/${item.id}`);
          }}
        >
          <i className="bx bx-edit"></i>
        </Button>
        <Button
          color="danger"
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteClick(item);
            // toggleDeleteModal();
          }}
        >
          <i className="bx bx-trash"></i>
        </Button>
      </div>
    </div>
  </Card>
</Col>

                );
              })}
            </Row>
          </>
        )}
      </div>

      {/* Delete Modal */}
      <DeleteModal
              show={isOpenDelete}
              onCloseClick={toggleDelete}
              onDeleteClick={handleDelete}
            />
    </Container>
  );
};

export default Video;
